import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import { Lottery, Offer } from '../../models/offer.model';

@Injectable({
  providedIn: 'root'
})
export class PickerService {
  lottery: Lottery;
  offer: Offer;
  baseCount: number;
  basePick: any[] = [];
  extraPick: any[] = [];

  constructor() {
    this.loadLandingData();
  }

  loadLandingData(): void {
    const landing: any = environment;
    this.lottery = landing.hasOwnProperty('lottery') ? landing.lottery : null;
    this.offer = this.lottery.hasOwnProperty('offer') ? this.lottery.offer : null;
    this.baseCount = this.offer && this.offer.hasOwnProperty('picks') ? this.offer.picks.count : null;
  }

  /**
   * Organize the picker object, if it is for metalate, it receives the modifier parameters for revancha and revanchita.
   * @param picksData
   */
  setUserPicks(picks, modifier?): void {
    picks.map((picker: [], index) => {
      if (picker.length >= this.baseCount) {
        let pickerAux = picker;
        let base = pickerAux.splice(0, this.baseCount);
        if (this.basePick[index]) {
          this.basePick[index] = [];
          this.extraPick[index] = [];
          this.basePick[index] = base.toString();
          this.extraPick[index] = pickerAux.toString();
        } else {
          this.basePick.push(base.toString());
          this.extraPick.push(pickerAux.toString());
        }
      }
    });
    let userPicks: {} = {
      base: this.basePick,
      modifier: (modifier) ? modifier : null,
      extra: this.extraPick
    };
    localStorage.setItem('userPicks', JSON.stringify(userPicks));
  }

  getUserPicks(): { base; modifier; extra } {
    return JSON.parse(localStorage.getItem('userPicks')) || null;
  }
}
